// extracted by mini-css-extract-plugin
export default {"announce":"Announce_announce__fpmeS"};